/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Banner200,
  GetApiV1Banner401,
  GetApiV1Banner500,
  GetApiV1BannerQueryParams,
  GetApiV1BannerQueryResponse,
} from "../../types/bannerRegistroController/GetApiV1Banner.ts";
import { bannerListItemViewModelPaginatedResponseSchema } from "../bannerListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1BannerQueryParamsSchema = z.object({
  companyId: z.optional(z.coerce.number().int()),
  title: z.optional(z.string()),
  active: z.optional(z.boolean()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1BannerQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Banner200Schema = z.lazy(
  () => bannerListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Banner200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Banner401Schema =
  z.any() as unknown as ToZod<GetApiV1Banner401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Banner500Schema =
  z.any() as unknown as ToZod<GetApiV1Banner500>;

export const getApiV1BannerQueryResponseSchema = z.lazy(
  () => getApiV1Banner200Schema,
) as unknown as ToZod<GetApiV1BannerQueryResponse>;
